import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActionItemLifeCycleModalValues } from '../../models/action-item-life-cycle-modal-values';
import { ActionItemDetails } from '../../models/action-item-details';
import { ExtendedActionItem } from '../../models/extend-action-item';
import { MessageService } from 'primeng/api';
import { ActionPlanService } from '../../services/action-plan.service';
import { ActionItemConstants } from '../../constants/action-item-constants';
import { ActionPlanDetails } from '../../models/action-plan-details';
import { ActionItemStatus } from '../../enums/action-item-status';
import { catchError, throwError } from 'rxjs';
import { SpinnerService } from '../../../../shared/services/spinner.service';
import { AuthenticationHelperService } from '../../../../shared/components/authentication-maintainance/services/authentication-helper.service';

@Component({
  selector: 'app-action-item-modals',
  templateUrl: './action-item-modals.component.html',
  styleUrls: ['./action-item-modals.component.scss']
})
export class ActionItemModalsComponent implements OnInit {

  @Input() actionItemLifeCycleModalValues!: ActionItemLifeCycleModalValues;
  @Input() actionItem!: ActionItemDetails;
  @Input() eventType!: string;
  @Input() preFilledReason: string = '';
  @Output() closeModel = new EventEmitter<boolean>();
  @Output() actionPlanData = new EventEmitter<ActionPlanDetails>();
  
  updatedActionPlan!: ActionPlanDetails;
  extendActionItem: ExtendedActionItem = {} as ExtendedActionItem;
  reason = this.actionItem?.actionTaken;
  isModalVisable = false;
  isReasonForActionItemUpdateRequired = false;
  reasonValidationMessage : string = "";
  updatedActionPlanDetail! : ActionPlanDetails;

  constructor(private messageService: MessageService, private actionPlanService: ActionPlanService, private spinnerService: SpinnerService,
    private readonly authenticationHelperService: AuthenticationHelperService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.isModalVisable = true;
    this.updateActionItemData();
    if(this.actionItemLifeCycleModalValues?.inputLabel == ActionItemConstants.ActionItem_VerifierNotesModal_InputLabel){
      this.reason=this.actionItem?.verifierNotes
    }
  }

  updateActionItemData(){
    this.reason = this.preFilledReason;
    if(this.actionItem != null && this.actionItem != undefined){
      this.extendActionItem.changeControlNumber = this.actionItem.changeControlNumber;
    this.extendActionItem.actionItemNumber = this.actionItem.actionItemNumber;
    this.extendActionItem.sourceStatus = this.actionItem.status != null ? this.actionItem.status : 0,
    this.extendActionItem.event = this.eventType,
    this.extendActionItem.targetStatus = null,
    this.extendActionItem.reason = null,
    this.getTargetStatus(this.actionItemLifeCycleModalValues.buttonLabel); // Get Target Status through button Label
    }
  }

  getTargetStatus(buttonLabel: string){
    switch(buttonLabel){
      case ActionItemConstants.ActionItem_SpeedDialButton_Complete:
        this.extendActionItem.targetStatus = ActionItemStatus.Complete;
        break;
      case ActionItemConstants.ActionItem_SpeedDialButton_Defer:
        this.extendActionItem.targetStatus = ActionItemStatus.Defer;
        break;
      case ActionItemConstants.ActionItem_SpeedDialButton_Void:
        this.extendActionItem.targetStatus = ActionItemStatus.Void;
        break;
      case ActionItemConstants.ActionItem_SpeedDialButton_Verify:
        this.extendActionItem.targetStatus = null;
        break;
      case ActionItemConstants.ActionItem_SpeedDialButton_Reject:
        this.extendActionItem.targetStatus = ActionItemStatus.Pending;
        break;
    }
  }

  reAuthenticate() {
    // Checks for mandatory field - if input is Mandatory, checks for reason data or else it shifts to other or condition
    if ((this.actionItemLifeCycleModalValues?.isInputMandatory && this.reason != null && this.reason != undefined
      && this.reason.length > 0) || !this.actionItemLifeCycleModalValues?.isInputMandatory || this.actionItemLifeCycleModalValues.inputLabel == ActionItemConstants.ActionItem_VerifierNotesModal_InputLabel) {
      // check if Modal is for rejection, then no re-Auth needed
      if (this.actionItemLifeCycleModalValues.title == ActionItemConstants.ActionItem_RejectModal_Title) {
        this.UpdateActionItem();
      }
      else {
        this.authenticationHelperService.reauth(
          this.UpdateActionItem.bind(this), () => { }
        );
      }
    } 
    else 
    {
        this.reasonValidationMessage = this.actionItemLifeCycleModalValues.inputLabel + ActionItemConstants.ReasonValidationMessage;
      this.isReasonForActionItemUpdateRequired = true;
    }
  }

  UpdateActionItem = () => {
    this.spinnerService.show();
    this.reasonValidationMessage = '';
      this.extendActionItem.reason = this.reason;
      if(this.actionItemLifeCycleModalValues.inputLabel == ActionItemConstants.ActionItem_VerifierNotesModal_InputLabel){
        this.extendActionItem.reason = ''
        this.extendActionItem.verifierNotes = this.reason
      }
        this.actionPlanService.updateActionItem(this.extendActionItem)
        .pipe(
          catchError((err) => {
            this.messageService.add({
              severity: ActionItemConstants.Severity_Err,
              summary: `${err.error}`,
            });
            this.spinnerService.hide();
            return throwError(() => err);
          })
        )
        .subscribe(
        serviceData => {
          this.messageService.add({
            severity: ActionItemConstants.Severity_Info,
            summary: ActionItemConstants.ActionItem_Update_Complete
          });        
          this.updatedActionPlanDetail = serviceData; // Store Action Plan data
          this.actionPlanData.emit(this.updatedActionPlanDetail); // Event Emitter to transfer data back to Action Item Management Screen
          this.closeModel.emit(false); // Event Emitter to close down reason Modal
          this.spinnerService.hide();
          this.changeDetectorRef.detectChanges();
      });
  }
  
  closeReasonDialog(){  
    this.isModalVisable = false;
    this.closeModel.emit(this.isModalVisable);
  }
  
  onDialogHide(){
    this.isModalVisable = false;
    this.closeModel.emit(this.isModalVisable) ;
  }

}
